<template>
  <router-view></router-view>
</template>

<script>
import { CONFIG } from "./config/";

export default {
  name: 'app',
  components: {},
  mounted() {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${CONFIG.GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    document.body.appendChild(script);
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/app.vue